<mat-form-field appearance="fill">
  <mat-label>Dokumentum típusa</mat-label>
  <mat-select [formControl]="selectControl" [panelWidth]="null">
    @if (addEmptyElement) {
      <mat-option [value]=""><strong>Összes mutatása</strong></mat-option>
    }
    @for (dt of documentTypes; track dt) {
      <mat-option [value]="dt.key">
        {{dt.value}}
      </mat-option>
    }
  </mat-select>
  <mat-error>Kötelező választani</mat-error>
</mat-form-field>
